import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const assetBackedFinanceCriteria = [
  ...sharedCriteriaFields(),
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        optionsColumns: 4,
        field: 'assetType',
        type: 'multiple',
      },
    ],
    label: 'Types of asset to finance',
  },
  {
    fields: [
      {
        optionsColumns: 6,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    fields: [
      {
        columns: 12,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'useOfFunds',
        optionsColumns: 4,
        type: 'multiple',
      },
    ],
    label: 'For what funding purposes is this product suitable?',
  },
];

export const assetBackedFinanceFees = sharedFeesFields(true);
